import React, { useMemo } from "react";
import PropTypes from "prop-types";
import * as SharedStyle from "../../shared-style";
import { MODE_FINISHING_PLAN } from "../../constants";

/**
 * Vertex handle. IMPORTANT: never put HTML heading tags or CSS transform translate
 * inside SVG — with parent scale(1,-1)/translate that causes "translate parent"
 * ghosts, stair-step artifacts, and wrong hit targets.
 */
export default function Vertex({ vertex, layer }, { store }) {
  let { x, y } = vertex;
  const mode = useMemo(() => {
    try {
      return store.getState().getIn(["react-planner", "mode"]);
    } catch (e) {
      return null;
    }
  }, [store]);

  if (mode === MODE_FINISHING_PLAN) return null;

  return (
    <g
      transform={`translate(${x}, ${y})`}
      data-element-root
      data-prototype={vertex.prototype}
      data-id={vertex.id}
      data-selected={vertex.selected}
      data-layer={layer.id}
    >
      <rect
        x={-4}
        y={-4}
        width={8}
        height={8}
        fill="gray"
        stroke={SharedStyle.COLORS.white}
        strokeWidth={1}
        style={{ cursor: "move" }}
      />
    </g>
  );
}

Vertex.propTypes = {
  vertex: PropTypes.object.isRequired,
  layer: PropTypes.object.isRequired,
};
Vertex.contextTypes = {
  store: PropTypes.object.isRequired,
};
